import { AddCircle } from '@mui/icons-material'
import { DataTable } from '../../../components'
import { ConfirmDeleteModal } from './ConfirmDeleteModal'
import ModalRegister from './modal-register'
import ModalUpdate from './modal-update'

import { useAuth } from '@/hooks'
import { useCollaboratorStore } from '@/stores/collaborators'
import { Alert, Button } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { MakeTABLE_COLUMNS } from './table-columns'
import { useData } from './use-data'

export default function Collaborators() {
  const { isLoading, error, users, deleteItem } = useData()

  const { user } = useAuth()
  const { collaboratorID } = useCollaboratorStore()
  const [isOpenUpdateModal, setIsOpenUpdateModal] = useState(false)
  const [isModalRegisterOpen, setIsModalRegisterOpen] = useState<boolean>(false)
  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] =
    useState(false)
  const [userToDelete, setUserToDelete] = useState<{
    id: string
    name: string
  } | null>(null)

  const toggleModalRegister = useCallback(
    () => setIsModalRegisterOpen(!isModalRegisterOpen),
    [isModalRegisterOpen],
  )

  const handleDeleteClick = useCallback((userId: string, userName: string) => {
    setUserToDelete({ id: userId, name: userName })
    setIsConfirmDeleteModalOpen(true)
  }, [])

  const handleConfirmDelete = useCallback(() => {
    if (userToDelete) {
      deleteItem(userToDelete.id)
      setIsConfirmDeleteModalOpen(false)
      setUserToDelete(null)
    }
  }, [deleteItem, userToDelete])

  useEffect(() => {
    setIsOpenUpdateModal(!!collaboratorID)
  }, [collaboratorID])

  if (error) return <Alert severity="error">{(error as Error).message}</Alert>

  return (
    <>
      <ModalUpdate open={isOpenUpdateModal} />
      <ModalRegister open={isModalRegisterOpen} onClose={toggleModalRegister} />
      <ConfirmDeleteModal
        open={isConfirmDeleteModalOpen}
        onClose={() => setIsConfirmDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        userName={userToDelete?.name || ''}
      />
      <section className="rounded-t-lg -mb-2 bg-tertiary w-full">
        <div className="p-4 flex items-center justify-between">
          <div>
            <h3 className="text-lg font-bold">Colaboradores</h3>
            <p className="text-[#969696] text-xs font-bold">
              Outros Administradores do Sistema
            </p>
          </div>
          <Button onClick={toggleModalRegister}>
            <AddCircle />
            <span>Registar</span>
          </Button>
        </div>
      </section>

      <DataTable
        data={users ?? []}
        isLoading={isLoading}
        columns={MakeTABLE_COLUMNS({
          deleteItem: async (id: string) => handleDeleteClick(id, ''),
          id: user?.id,
        })}
      />
      <div className="pb-7" />
    </>
  )
}
